'use client';
import { BREAKPOINTS } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const ContentMaxWidth = styled.div`
    max-width: 72rem;
    margin-right: auto;
    margin-left: auto;

    @media (min-width: ${BREAKPOINTS.XXL}px) {
        max-width: 80rem;
    }
`;

export default ContentMaxWidth;
